import { render, staticRenderFns } from "./magazineDetailPopUp.vue?vue&type=template&id=16920ee8&"
import script from "./magazineDetailPopUp.vue?vue&type=script&lang=js&"
export * from "./magazineDetailPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports